import { createContext } from 'react';
import { DiagramState } from './diagram.store';
import { StoreApi } from 'zustand';

export const DiagramStoreContext = createContext<StoreApi<DiagramState> | null>(
  null
);
